module.exports = __webpack_public_path__ + "static/media/iconMagic.b20e4219.svg";